module.exports = __webpack_public_path__ + "static/media/ic_arrow.e780c590.svg";